<template>
  <div class="one-click-open">
    <!-- Header Section -->
    <div class="header-section">
      <div class="robot-greeting">
        <img :src="robotImg" alt="robot" class="robot-img" />
        <div class="speech-bubble">
          {{ $t('investorList.s1') }}
        </div>
      </div>
      <div class="sun-section">
        <a-icon type="sun" theme="filled" class="sun-icon" />
      </div>
    </div>

    <!-- Center Section -->
    <div class="center-section">
      <img :src="centerImg" alt="center illustration" class="center-img" />
    </div>

    <!-- Cards Section -->
    <div class="cards-section">
      <a-row :gutter="[16, 16]" type="flex" justify="space-between">
        <a-col v-for="(item, index) in cardList" :key="index" :xs="12" :sm="8" :md="4">
          <div class="feature-card" :style="{ backgroundColor: item.bgColor }" @click="handleCardClick(item)">
            <div class="card-icon" :style="{ color: item.iconColor }">
              <a-icon :type="item.icon" />
            </div>
            <div class="card-title">{{ item.title }}</div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import robotImg from '@/assets/jiqiren.png'
import centerImg from '@/assets/3.jpg'

export default {
  name: 'OneClickOpen',
  data() {
    return {
      robotImg,
      centerImg,
      cardList: [
        {
          title: this.$t('investorList.s2'),
          icon: 'file-text',
          bgColor: '#d6e4ff',
          iconColor: '#597ef7',
          path: '/webpublic/Monitoring/branchallcountListForDate',
        },
        {
          title: this.$t('investorList.s3'),
          icon: 'filter',
          bgColor: '#d9f7be',
          iconColor: '#73d13d',
          path: '/webpublic/Monitoring/Operations/custConvertRealList',
        },
        {
          title: this.$t('investorList.s4'),
          icon: 'team',
          bgColor: '#e6fffb',
          iconColor: '#36cfc9',
          path: '/webpublic/Monitoring/Operations/register',
        },
        {
          title: this.$t('investorList.s5'),
          icon: 'login',
          bgColor: '#f4ffb8',
          iconColor: '#a0d911',
          path: '/webpublic/Monitoring/Operations/login',
        },
        {
          title: this.$t('investorList.s6'),
          icon: 'sync',
          bgColor: '#feffe6',
          iconColor: '#fadb14',
          path: '/webpublic/Monitoring/Operations/reborrowCountForSubmitInstallment',
        },
        {
          title: this.$t('investorList.s7'),
          icon: 'money-collect',
          bgColor: '#ffe7ba',
          iconColor: '#ffa940',
          path: '/webpublic/Monitoring/Operations/reborrowCountInstallment',
        },
      ],
    }
  },
  methods: {
    handleCardClick(item) {
      if (item.path) {
        this.$router.push({ path: item.path })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.one-click-open {
  padding: 24px;
  margin: 0 -24px;
  border-radius: 12px;
  background-color: #fff;
  min-height: 90vh;
  display: flex;
  flex-direction: column;

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .robot-greeting {
      display: flex;
      align-items: center;

      .robot-img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }

      .speech-bubble {
        position: relative;
        background-color: #13bb68;
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 14px;
        color: #333;

        &::before {
          content: '';
          position: absolute;
          left: -8px;
          top: 50%;
          transform: translateY(-50%);
          border-width: 4px 8px 4px 0;
          border-style: solid;
          border-color: transparent #d6e4ff transparent transparent;
        }
      }
    }

    .sun-section {
      .sun-icon {
        font-size: 32px;
        color: #ffc53d;
      }
    }
  }

  .center-section {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;

    .center-img {
      max-width: 80%;
      max-height: 500px;
      object-fit: contain;
    }
  }

  .cards-section {
    .feature-card {
      min-height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      border-radius: 12px;
      padding: 20px 12px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .card-icon {
        font-size: 40px;
        margin-bottom: 12px;
        opacity: 0.7;
        flex-shrink: 0;
      }

      .card-title {
        font-size: 13px;
        font-weight: 600;
        text-align: center;
        color: #000;
        overflow-wrap: break-word;
        word-break: break-word;
        line-height: 1.4;
        padding: 0 4px;
        margin-top: auto;
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .one-click-open {
    padding: 12px;

    .center-section {
      .center-img {
        max-width: 100%;
      }
    }

    .cards-section {
      .feature-card {
        height: 100px;
        margin-bottom: 12px;
        padding: 12px 8px;
      }
    }
  }
}
</style>
